(function() {
  'use strict';

  function yearsUntilNow(value) {
    let now = new Date();
    let date = new Date(value);
    // do not count started year
    let time = new Date(now.getTime() - date.getTime());
    let years = time.getFullYear() - 1970; // unix time 1.1.1970 00:00
    return years.toString();
  }

  let elList = document.querySelectorAll("h1, h2, h3, h4, h5, h6, p");
  let exp = /###(.)+###/;
  elList.forEach(function(el) {
    if (el.innerHTML.indexOf("###") !== -1) {
      let html = el.innerHTML;
      let mark = html.match(exp);
      if (mark) {
        let markString = mark[0];
        let markNode = markString.replaceAll('###', '').split(':');
        let markName = markNode[0];
        let markValue = markNode[1];
        switch (markName) {
          case 'years-until-now':
            let years = yearsUntilNow(markValue);
            if (years) {
              el.innerHTML = html.replace(markString, years);
            }
            break;
        }
      }
    }
  });
})();
